
import { required } from 'vuelidate/lib/validators'

export default {
  bike: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    garage_id: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/form/resources/validations.js